module.exports = __webpack_public_path__ + "media/images/pages/trade-free-trial-2cbd604ecfa10963c4902d9a25f4c3ff.svg";